import React from 'react';
import { Form } from 'react-bootstrap';

import './redactor.min';
import './plugins/fontcolor.min';
import './plugins/fontsize.min';
import './plugins/imagemanager.min';
import './plugins/video.min';
import './plugins/table.min';
import './plugins/fullscreen.min';

import './css/redactor.css';


export default class ContentRedactor extends React.Component {
  constructor(props) {
    super(props);
    this.redactorRef = React.createRef();
    this.redactor = null;
    this.config = {
      source: false,
      minHeight: '200px',
      maxHeight: '600px',
      toolbarFixed: false,
      buttons: ['format', 'bold', 'italic', 'deleted', 'underline', 'sup', 'sub', 'ol', 'ul', 'link', 'image'],
      plugins: ['fontcolor', 'fontsize', 'imagemanager', 'video', 'table', 'fullscreen'],
      imageUpload: '/images/upload/',
      imageManagerJson: '/images/recent/',
      callbacks: {
        changed: function(html)
        {
          props.input.onChange(html);
          return html;
        },
        focus: function () {
          props.input.onFocus();
        },
        blur: function () {
          props.input.onBlur();
        }
      }
    }
  }

  componentDidMount() {
    let app = Redactor(this.redactorRef.current, this.config);
    this.redactor = app;
  }

  componentWillUnmount() {
    Redactor(this.redactorRef.current, 'destroy');
    this.redactor = null;
  }

  render() {
    let { input, meta, label, placeholder, required } = this.props;
    let validate_class = '';
    if (meta.touched){
      meta.error ? validate_class = ' is-invalid' : validate_class = ' is-valid';
    }
    return <Form.Group controlId={ input.name + '_id' } bsPrefix={'form-group' + validate_class}>
      { label && <label className='form-label' htmlFor={ input.name + '_id' }>{ label } { required && '*' }</label> }
      <textarea ref={ this.redactorRef }
                name={ input.name }
                placeholder={ placeholder }
                value={ input.value }
                id={ input.name + '_id' }/>
      { (meta.touched && meta.error) && <Form.Control.Feedback type="invalid">{ meta.error }</Form.Control.Feedback> }
      </Form.Group>
  }
}